export enum ShipmentStatus {
  planned,
  shipped
}

/**
 * What CreateShipment returns — the header alone; lines are added from the
 * client-order page (0015: no position picker on the shipment side yet).
 */
export interface ShipmentHeaderDto {
  id: number;
  shipmentNumber: string;
  transport: string;
  plannedDate: string | null;
  status: ShipmentStatus;
  shippedAt: string | null;
  createdAt: string;
}

export interface ShipmentDto extends ShipmentHeaderDto {
  /**
   * Lines grouped under their zamówienie — one wysyłka may carry positions of several.
   */
  groups: ShipmentGroupDto[];
}

export interface ShipmentGroupDto {
  clientOrderId: number;
  clientOrderNumber: string;
  clientName: string;
  items: ShipmentItemDto[];
}

export interface ShipmentItemDto {
  shipmentItemId: number;
  clientOrderItemId: number;
  name: string;
  unit: string;
  /**
   * How much of the position this shipment carries, next to the ordered total — both
   * in the position's unit.
   */
  amount: number;
  orderedAmount: number;
  /**
   * The line's client-order position's photo — frozen there, else its BOM item's current
   * one; null when neither (0082). Absent on the create response, which never carries it.
   */
  primaryPhotoAttachmentId?: number | null;
}

/**
 * The editable header — what CreateShipment and PatchShipment both take.
 */
export interface ShipmentHeader {
  transport: string;
  plannedDate: string | null;
}
